/** Indian GST state codes (mirrors server/utils/gstStates.js). */
export const GST_STATES = [
  { code: '01', name: 'Jammu & Kashmir' },
  { code: '02', name: 'Himachal Pradesh' },
  { code: '03', name: 'Punjab' },
  { code: '04', name: 'Chandigarh' },
  { code: '05', name: 'Uttarakhand' },
  { code: '06', name: 'Haryana' },
  { code: '07', name: 'Delhi' },
  { code: '08', name: 'Rajasthan' },
  { code: '09', name: 'Uttar Pradesh' },
  { code: '10', name: 'Bihar' },
  { code: '11', name: 'Sikkim' },
  { code: '12', name: 'Arunachal Pradesh' },
  { code: '13', name: 'Nagaland' },
  { code: '14', name: 'Manipur' },
  { code: '15', name: 'Mizoram' },
  { code: '16', name: 'Tripura' },
  { code: '17', name: 'Meghalaya' },
  { code: '18', name: 'Assam' },
  { code: '19', name: 'West Bengal' },
  { code: '20', name: 'Jharkhand' },
  { code: '21', name: 'Odisha' },
  { code: '22', name: 'Chhattisgarh' },
  { code: '23', name: 'Madhya Pradesh' },
  { code: '24', name: 'Gujarat' },
  { code: '26', name: 'Daman and Diu, Dadra & Nagar Haveli' },
  { code: '27', name: 'Maharashtra' },
  { code: '28', name: 'Andhra Pradesh (before bifurcation)' },
  { code: '29', name: 'Karnataka' },
  { code: '30', name: 'Goa' },
  { code: '31', name: 'Lakshadweep' },
  { code: '32', name: 'Kerala' },
  { code: '33', name: 'Tamil Nadu' },
  { code: '34', name: 'Puducherry' },
  { code: '35', name: 'Andaman & Nicobar Islands' },
  { code: '36', name: 'Telangana' },
  { code: '37', name: 'Andhra Pradesh (New)' },
  { code: '38', name: 'Ladakh' },
];

export function stateNameFromCode(code) {
  const key = String(code || '').trim().slice(0, 2);
  const row = GST_STATES.find((s) => s.code === key);
  return row?.name || '';
}

export function stateCodeFromGstin(gstin) {
  const raw = String(gstin || '').trim().toUpperCase();
  if (raw.length >= 2 && /^\d{2}/.test(raw)) return raw.slice(0, 2);
  return '';
}

export function formatStateLabel(code) {
  const key = String(code || '').trim().slice(0, 2);
  if (!key) return '';
  const name = stateNameFromCode(key);
  return name ? `${name} (${key})` : key;
}

/** Prefer GSTIN prefix; else keep value only if it is a known 2-digit GST code. */
export function resolveOrgStateCode(gstin, stateCode) {
  const fromGstin = stateCodeFromGstin(gstin);
  if (fromGstin) return fromGstin;
  const key = String(stateCode || '').trim().slice(0, 2);
  if (/^\d{2}$/.test(key) && stateNameFromCode(key)) return key;
  return '';
}
